import * as React from 'react';
import { Box, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { theme } from 'configs';

interface NavItemProps {
  icon?: React.ReactNode;
  prependIcon?: boolean;
  label?: string;
  variant?: string;
  align?: string;
  active?: boolean;
  style?: any;
  onClick?: Function;
}

export const NavItem: React.FC<NavItemProps> = (props) => {
  const {
    icon = null,
    prependIcon = true,
    label = 'Button',
    variant = 'text',
    align = 'center',
    active = false,
    style = {},
    onClick = () => {},
  } = props;

  const useStyles = makeStyles({
    nonActiveTextNavItem: {
      color: `${theme.palette.text.secondary} !important`,
      '&:hover': {
        color: `${theme.palette.primary.main} !important`,
        backgroundColor: `${theme.palette.primary.main}20 !important`,
      },
    },
  });

  const classes = useStyles();

  return (
    <Button
      variant={variant as any}
      className={`${variant === 'text' && !active ? classes.nonActiveTextNavItem : ''}`}
      onClick={() => onClick()}
      sx={{
        justifyContent: align === 'center' ? 'center' : align === 'left' ? 'flex-start' : 'flex-end',
        paddingX: 2,
        ...style,
        transition: theme.transitions.create(['margin', 'padding'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }}
    >
      <Box display="flex" alignItems="center">
        {icon && prependIcon && (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: 40 }}>
            <Box sx={{ width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {icon}
            </Box>
          </Box>
        )}
        {label}
        {icon && !prependIcon && (
          <Box display="flex" alignItems="center" marginLeft={1}>
            {icon}
          </Box>
        )}
      </Box>
    </Button>
  );
};
